import type { SupabaseClient } from '@supabase/supabase-js';
import type {
  ITelemetryRepository,
  TelemetrySurface,
} from '../../../interfaces/src';

/**
 * Writes in-app screen views to `track_tenant_page_view`.
 *
 * The RPC resolves the workspace from the session, drops anything that does
 * not look like a route pattern, and ignores platform admins browsing through
 * tenant view. Nothing here throws: a failed navigation ping must never reach
 * a customer's screen, and it is not worth a retry.
 */
export class SupabaseTelemetryRepository implements ITelemetryRepository {
  constructor(private supabase: SupabaseClient) {}

  async trackPageView(
    route: string,
    surface: TelemetrySurface,
  ): Promise<void> {
    try {
      await this.supabase.rpc('track_tenant_page_view', {
        p_route: route,
        p_surface: surface,
      });
    } catch {
      // Best effort by contract.
    }
  }
}
